<template>
  <div class="container bottom">
    <div class="header bottom-shadow">
      <label>Route Alias</label>
    </div>

    <div class="mid-container">
      <div class="input-container">
        <label>Alias:</label>
        <input v-model="alias" type="text" name="alias" v-validate="'required'" :class="{'error': errors.has('alias')}" placeholder="Your Alias"></input>
        <span v-show="errors.has('alias')" class="error-message">{{ errors.first('alias') }}</span>
        <p class="description">Alias is used by users to connect to your event's channel. This way they will receive the event's pep points and live messages. It is mandatory for the event to have an Alias.</p>
      </div>
    </div>

  <BottomNav @previousPage="previousPage()" @nextPage="nextPage()" pText="Back" pColor="blue" nText="Done!" nColor="green" />

  </div>
</template>

<script>

import Vue from 'vue/dist/vue.js'
import BottomNav from './BottomNav'
import firebase from 'firebase'
import { store } from '../store/store'
import { mapGetters } from 'vuex'
import axios from 'axios'
import { createHelpers } from 'vuex-map-fields'
import MapManager from '../helpers/mapManager'

const { mapFields } = createHelpers({
  getterType: 'getInfoField',
  mutationType: 'updateInfoField',
})

export default {
  name: 'eventKey',
  title: 'Runner - Alias',
  components: {
    BottomNav
  },
  data() {
    return {
      alias: ''
    }
  },
  computed: {
    ...mapGetters([
      'currentRaceId'
    ]),
  },
  asyncComputed: {
    showAdminContent() {
      return new Promise((resolve, reject) => {
        firebase.auth().currentUser.getIdTokenResult()
        .then((idTokenResult) => {
          // Confirm the user is an Admin.
          console.log("Checking if user is admin")
          console.log(idTokenResult)
          if (idTokenResult.claims.admin && this.$route.params.addEvent) {
            console.log("resolving true")
           resolve(true)
         } else {
           console.log("resolving false")
           resolve(false)
         }
        })
        .catch((error) => {
          console.log(error)
          resolve(false)
        })
      })
    }
  },
  methods: {
    nextPage() {
      this.validateBeforeSubmit()
    },
    previousPage() {
      const addEvent = this.showAdminContent
      this.$router.replace({ name: 'Information', params: { 'addEvent': addEvent } })
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitAlias()
          return
        }
      })
    },
    submitAlias() {
      //this.$store.dispatch('submitAlias', this.alias.id).then(() => {
        if(this.showAdminContent) {
          //Add event to Events /events
          firebase.auth().currentUser.getIdToken().then((token) => {
            axios({
             method: 'post', //you can set what request you want to be
             //url: 'http://localhost:5000/racepeps/us-central1/eventAdmin/event',
             url: 'https://us-central1-racepeps.cloudfunctions.net/eventAdmin/event',
             data: {'raceId': this.currentRaceId, 'alias': this.alias },
             headers: {
               'Authorization': 'Bearer ' + token
             }
            })
            .then(response => {
              console.log(response)
              this.$router.replace('newRace')
              MapManager.clearMap()
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              var msg = error.request.responseText || "Something went wrong. Couldn't create event."
              alert(msg)
            })
          })
        } else {
          console.log("Not doing anything. Normal user shouldn't even be here...")
        }
      /*}).catch(() => {
        console.log("Something went wrong while submitting alias!")
      })*/

    },
  }

}
</script>

<style lang="scss" scoped>

  @import '../styles/styles.scss';

  .mid-container {
    padding: 10%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    flex: 9;

    p {
      line-height: 1.4;
    }

  }

  .description {
    text-align: center;
  }

  .error {
    border: 2px solid red;
    outline: none;
  }

  @media screen and (min-width: 1140px) {
    .container.bottom {
      width: 600px;
      height: 360px;
    }

    .mid-container {
      padding: 1% 15% 1%;
      justify-content: center;
    }
  }

</style>
